module.exports = __webpack_public_path__ + "static/media/shapes_28.aae9075d.svg";